import React from "react";
import challengeImg from "../assest/challengespace.png";

interface ChallengeSpaceProps {
  title?: string;
  subtitle?: string;
  description?: string;
}

const ChallengeSpace: React.FC<ChallengeSpaceProps> = ({
  title = "Challenge Space",
  subtitle = "Compete & Conquer",
  description = "What’s life Without a little Competition ? Compete with friends, climb leaderboards, and unlock achievements as you take on daily, weekly, and monthly challenges that transform your goals into thrilling adventures.",
}) => {
  return (
    <div className="flex items-center justify-center w-full bg-zinc-900 text-white px-6 py-16 md:py-24 md:px-12 lg:px-20">
      <div className="relative max-w-6xl mx-auto w-full">
        <div className="relative flex flex-col md:flex-row-reverse items-center gap-8 bg-transparent rounded-lg">
          {/* Image Section */}
          <div className="w-full md:w-1/2 flex justify-center">
            <div className="relative w-[80%] sm:w-[75%] md:w-[548px] h-auto">
              <img
                src={challengeImg}
                alt="Challenge Space"
                className="w-full h-auto object-cover rounded-[32px]"
              />
            </div>
          </div>

          {/* Text Content Section */}
          <div className="w-full md:w-1/2 px-4 sm:px-8 md:px-6 flex flex-col justify-center text-center md:text-left">
            <h3 className="text-orange-500 text-lg sm:text-xl font-semibold mb-2 font-robotoSerif">
              {subtitle}
            </h3>
            <h2 className="text-white text-3xl sm:text-4xl md:text-5xl font-bold font-inter leading-tight">
              {title}
            </h2>
            <p className="text-gray-300 text-base sm:text-lg font-dmSans mt-4">
              {description}
            </p>
            <div className="w-full max-w-md mx-auto md:mx-0 mt-6">
              <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
                <span className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-lg px-6 py-3 font-semibold">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m.5-13H11v6l5.2 3.2.8-1.3-4.5-2.7V7z" />
                  </svg>
                  Coming Soon
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengeSpace;
